import type { PlanSession } from './types';

export type NextSessionAction = 'start' | 'prepare' | 'stop';

export interface SessionCompletionResult {
  completedSession: PlanSession;
  nextSession: PlanSession | null;
  planCompleted: boolean;
}

interface NextSessionActionInput {
  hasNextSession: boolean;
  autoStart: boolean;
}

export const getNextSessionAction = ({
  hasNextSession,
  autoStart
}: NextSessionActionInput): NextSessionAction => {
  if (!hasNextSession) return 'stop';
  return autoStart ? 'start' : 'prepare';
};

export const completeSessionState = (
  sessions: PlanSession[],
  activeSessionIndex: number,
  endedAt: string,
  expectedSessionId?: string | null
): SessionCompletionResult | null => {
  const session = sessions[activeSessionIndex];
  if (!session || session.completed || (expectedSessionId && session.id !== expectedSessionId)) return null;

  const completedSession: PlanSession = { ...session, completed: true, endedAt };
  const nextSession = sessions[activeSessionIndex + 1] ?? null;
  return {
    completedSession,
    nextSession,
    planCompleted: nextSession === null
  };
};
